import BarekamText from "../../../../../pages/components/text";
import { BarekamIcon } from "../../../../../pages/components/icon/barekam-icon";
import { OrderIcons } from "../../../../../pages/components/icon/variants";
import { GapContainer } from "../../../../../pages/components/card/styled";
import { StandardDialogFooter } from "../../../../../pages/components/dialogs/standard-dialog/standard-dialog";
import { Alert } from "@mui/material";
import BarekamInput from "../../../../../pages/components/input";
import Message from "../../../../../pages/components/message";
import { MessageSections } from "../../../../../pages/components/message/message";
import { AddProductDialogContent } from "../../styled";
import { getMessage } from "../../../../../pages/shared/helper-functions";
import { useAppSelector } from "../../../../../redux/store";

const FirstStep = ({ trackingNumber, errors, onChange, nextStep, closePopup }: FirstStepProps) => {
    const { messageCache, languageId } = useAppSelector(state => state.messagesReducer);

    return (
        <>
            <AddProductDialogContent>
                <BarekamInput value={trackingNumber}
                    key={'trackingNumber'}
                    placeholder={getMessage('tracking_number', MessageSections.ORDERS, messageCache, languageId)}
                    customInputVariant={"standard"}
                    width={'100%'}
                    error={!!errors['trackingNumber']}
                    errorMessage={errors['trackingNumber'] && getMessage(errors['trackingNumber'], MessageSections.ORDERS, messageCache, languageId)}
                    onChange={(event) => onChange('trackingNumber', event.target.value)}
                    onKeyUp={(event) => event.key === 'Enter' && nextStep()} />
                <GapContainer>
                    <BarekamIcon variant={OrderIcons.scanOrderGreen} />

                    <BarekamText variant={"m"} fontWeight={600} color={'#087E38'}>
                        <Message messageKey={'scan_or_input_tracking_number'} sectionId={MessageSections.ORDERS} />
                    </BarekamText>
                </GapContainer>

                {errors['trackingNumber']
                    ? <Alert severity="error">
                        <BarekamText variant={"m"}>
                            <Message messageKey={errors['trackingNumber']} sectionId={MessageSections.ORDERS} />
                        </BarekamText>
                    </Alert>
                    : ''
                }
            </AddProductDialogContent>

            <StandardDialogFooter key={'first-step-footer'}
                saveLabel={<Message messageKey={'continue'} sectionId={MessageSections.ORDERS} />}
                onSave={() => nextStep()}
                onCancel={() => closePopup()} />
        </>
    )
}

interface FirstStepProps {
    trackingNumber: string,
    errors: { [key: string]: string },

    onChange: (field: string, value: any) => void,
    nextStep: () => void;
    closePopup: () => void;
}

export default FirstStep;